import * as React from 'react';
import SurveyQuestion from './SurveyQuestion';
import getLangTranslation from '../../common/lang-trans';
import { QuestionModel } from '../../models/question.model';
import { GroupModel } from "../../models/group.model";
import { SurveyModel } from '../../models/survey.model';
import * as fromConstants from '../../common/constants';

interface iProps {
    language: string,
    errorInSubmit: boolean,
    isSubmitted: boolean,
    survey: SurveyModel,
    SubmitSurvey: any,
    SetValidationStatusAndValue: any
    SetValidationStatus: any
}

class SurveyQuestionnaire extends React.PureComponent<iProps> {

    componentDidUpdate() {

        this.validateAllFiels();
    }

    handleSubmit = () => {
        const isValid = this.validateAllFiels();
        this.props.SubmitSurvey(isValid);
    }

    handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.target.value = e.target.value;
        const isValid = this.ValidateInputValue(e.target.name, e.target.value);
          
        this.props.SetValidationStatusAndValue({
                questionId: +e.target.name,
                optionId: null,
                text: e.target.value,
                isOtherTextBoxChanged: false,
                isValid: isValid,
                isSubmitted: false
            });
    }

    handleMcqChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.target.value = e.target.value;
        const isValid = this.ValidateInputValue(e.target.name, e.target.value);
          
        this.props.SetValidationStatusAndValue({
                questionId: +e.target.name,
                optionId: +e.target.value,
                isChecked: e.target.checked,
                text: '',
                isValid: isValid,
                isSubmitted: false
            });

        this.validateAllFiels();
    };

    handleMatrixChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.target.value = e.target.value;
        const questionId = e.target.name.split('-')[0];
        const rowAndColumnId = e.target.value.split('-');

        const isValid = this.ValidateInputValue(questionId, e.target.value);
          
        this.props.SetValidationStatusAndValue({
                questionId: +questionId,
                rowId: +rowAndColumnId[0],
                columnId: +rowAndColumnId[1],
                optionId: null,
                isChecked: e.target.checked,
                text: '',
                isValid: isValid,
                isSubmitted: false
            });

        this.validateAllFiels();
    };

    handleMcqOtherChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.target.value = e.target.value;
        const isValid = this.ValidateInputValue(e.target.name, e.target.value);
          
        this.props.SetValidationStatusAndValue({
                questionId: +e.target.name,
                optionId: +e.target.id,
                isChecked: null,
                isOtherTextBoxChanged: true,
                text: e.target.value,
                isValid: isValid,
                isSubmitted: false
            });

        this.validateAllFiels();
    };

    private ValidateInputValue(questionId: string, value:string): boolean {

        const q = this.props.survey.questions.find(f => f.questionId === +questionId);

        if(q === undefined)
            return false;

        if (q.code === fromConstants.QuestionType_MCQ) {

            if (q.isMandatory && (q.mcqAnswers || []).length === 0)
                return false;

            if ((q.mcqAnswers || []).length > q.maxMcqValues && q.maxMcqValues !== -1)
                return false;

            if ((q.mcqAnswers || []).length < q.minMcqValues && q.minMcqValues !== -1)
                return false;

            const mcqOption = q.mcqOptions.find(f=> f.isOther === true);

            if (mcqOption) {
                const otherAnswer = (q.mcqAnswers || []).find(f => f.mcqOptionId === mcqOption.mcqOptionId);

                if (otherAnswer && (otherAnswer.answerEn.length === 0 || 
                        (q.maxCharacterLimit !== null && q.maxCharacterLimit > 0 && otherAnswer.answerEn.length > q.maxCharacterLimit))
                    )
                    return false;
            }

        } else if (q.code === fromConstants.QuestionType_MATRIX) {

            const matrixAns = (q.matrixAnswers || []);

            if (q.isMandatory === false)
                return true;

            for(let i = 0; i <  q.matrixRows.length; i++) {

                if (matrixAns.findIndex( e => e.matrixRowId === q.matrixRows[i].matrixId) === -1)
                    return false;
            }

            return true;

        } else {

            if (value === null || value === undefined)
                value = '';
            
            value = value.trim();

            if(q.isMandatory && value.length === 0)
                return false;

            if (!(q.code === fromConstants.QuestionType_Email || q.code === fromConstants.QuestionType_Phone)) {
                if (q.maxCharacterLimit !== null && q.maxCharacterLimit > 0 && value.length > q.maxCharacterLimit)
                    return false;
            }

            if (value !== '' && q.defaultRegex) {
                const rgx = new RegExp(q.defaultRegex);
                if (rgx.test(value) === false)
                    return false;
            }
        }
        return true;
    }

    private validateAllFiels(): boolean {
        let result = true;

        for(let i =0; i < this.props.survey.questions.length; i++) {
            const q = this.props.survey.questions[i];

            const isValid = this.ValidateInputValue(q.questionId.toString(), q.value);
            
            this.props.SetValidationStatus(q.questionId, isValid);

            result = result && isValid;
        }

        return result;
    }

    public render() {
        const questions = this.props.survey.questions;
        const groups = this.props.survey.groups;
        const language = this.props.language || 'en';
        const langTrans = getLangTranslation(language);

        const isValid = ( this.props.isSubmitted && 
                            this.props.survey.questions.findIndex(f => f.isValid === false) !== -1 );

        return (
            <React.Fragment>
                <div className="row g-2" >
                    <div className="col-sm-12 mb-2">
                        <label className="form-label fw-bold">{langTrans.AllAsteriskFields} <samp className="text-danger fw-bold">*</samp> {langTrans.AreMandatory}</label>
                    </div>
                    
                    {this.getQuestionElements(questions, groups)}

                    <div className="col-sm-12">
                        { isValid && <div className="invalid-feedback d-block pb-2">{ langTrans.FillOutAllRequiredFields }</div> }
                        <br />
                    </div>
                    { this.props.errorInSubmit && <div className="col-sm-12">
                         <div className="invalid-feedback d-block pb-2">{ langTrans.ErrorSubmitting }</div>
                        <br />
                    </div>}
                    <div className="col-sm-12">
                        <button className="btn btn-primary" onClick={this.handleSubmit}>{ langTrans.Submit }</button>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    private getQuestionElements(questions: QuestionModel[], groups: GroupModel[]) {

        let groupId : number | undefined = -99;

        const items = [];
        let isFirstGroup = true;
        for (var i = 0; i < questions.length; i++) {
            if (questions[i].groupId !== groupId) {
                
                const group = groups.find(f => f.groupId === questions[i].groupId);

                if (group) {
                    isFirstGroup = false;
                    items.push(
                        <div key={`g-${group.groupId}--q-${questions[i].questionId}`} className="col-sm-12 mt-4 mb-4">
                            {group.groupHeading !== null && group.groupHeading !== '' ? <p className="h3 fw-bold mb-1">{group.groupHeading}</p> : ''}
                            {group.groupSubHeading !== null && group.groupSubHeading !== '' ? <p className="h5">{group.groupSubHeading}</p> : ''}
                        </div>);
                } else if (isFirstGroup === false) {
                    items.push(
                        <div key={`g-X--q-${questions[i].questionId}`} className="col-sm-12">
                            <p className="h5">&nbsp;</p>
                        </div>); 
                }
            }

            items.push(<SurveyQuestion key={(questions[i].questionId <= 0 ? i : questions[i].questionId) + '-Question'} question={questions[i]}
                            changeEvent={this.handleChange}
                            changeMcqEvent={this.handleMcqChange}
                            changeMatrixEvent={this.handleMatrixChange}
                            changeMcqOtherEvent={this.handleMcqOtherChange}   
                            language={this.props.language}></SurveyQuestion>);

            groupId = questions[i].groupId;
        }

        return (
            <>
                {items}
            </>
        );
    }

};

export default SurveyQuestionnaire;
